import { withAuthenticationRequired } from '@auth0/auth0-react';
import { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';

import { home, MainRoutes, MobileRoutes } from './MainRoutes';
import { CustomPermission } from '../@types';
import { menuData } from '../configs/menu';
import { permittedLayouts, permittedRoutes } from '../configs/permissions';
import { useGetUserSystemPermissions } from '../queries/user-query';

const ThemeRoutes = () => {
  const [permissions, setPermissions] = useState<CustomPermission[]>();
  let layoutes: any = [];

  const getUserPermissionsQuery = useGetUserSystemPermissions();

  useEffect(() => {
    if (getUserPermissionsQuery.isSuccess && getUserPermissionsQuery.data) {
      setPermissions(getUserPermissionsQuery.data);
    }
  }, [getUserPermissionsQuery.isLoading, getUserPermissionsQuery.isSuccess]);

  if (permissions) {
    layoutes = permittedLayouts(menuData, permissions);
  }

  const filteredRoutes: any = permittedRoutes(layoutes, MainRoutes);
  filteredRoutes.children.push(home);

  const routes = useRoutes([filteredRoutes, MobileRoutes]);

  // Show nothing while permissions are loading to prevent
  // the home page flashing before the target route renders.
  if (!permissions) return null;

  return routes;
};

export default withAuthenticationRequired(ThemeRoutes);
